import Chip from "@mui/material/Chip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import { forwardRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { applyFilter, selectFilterById } from "../redux/search";
import { toDateOnlyString } from "../utils";
import DateRangeCalendar from "./DateRangeCalendar";
import TagsByType from "./Tag";

const DateChip = forwardRef(({ filterType, ...props }, ref) => {
  const dispatch = useDispatch();
  const filter = useSelector((state) => selectFilterById(state, filterType));
  const [anchorEl, setAnchorEl] = useState(null);

  const Tag = TagsByType[filterType];

  const MAX_MONTHS = filterType === "saleDate" ? 3 : 1;

  const open = Boolean(anchorEl);

  const openCalendar = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeCalendar = () => {
    setAnchorEl(null);
  };

  const onCalendarChange = ({ startDate, endDate }) => {
    dispatch(
      applyFilter({
        id: filterType,
        value: {
          start: toDateOnlyString(startDate),
          end: toDateOnlyString(endDate),
        },
      }),
    );
    closeCalendar();
  };

  return (
    <>
      <Chip
        ref={ref}
        {...props}
        label={<Tag value={props.value} />}
        onClick={openCalendar}
      />
      <Popper
        anchorEl={anchorEl}
        onClose={closeCalendar}
        open={open}
        placement="bottom-start"
        position="bottom-start"
        sx={{ zIndex: "tooltip" }}
        transition
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper className={props.className} elevation={4}>
              <ClickAwayListener onClickAway={closeCalendar}>
                <DateRangeCalendar
                  startDate={dayjs(filter.value?.start)}
                  endDate={dayjs(filter.value?.end)}
                  maxRangeMonths={MAX_MONTHS}
                  onChange={onCalendarChange}
                />
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
});

export default styled(DateChip)(
  ({ theme }) => `
    transform-origin: top left;
  `,
);
